// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_j0-0";
export var fileCarousel = "_j0-2";
export var removeFileButton = "_j0-1";